import React from 'react';
// eslint-disable-next-line
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { TomorrowLabel } from 'src/domains/sportsbook/webview/components/raceCard/tabs/TomorrowLabel';
import { TabsContent, TabsSection, TabsUl } from 'src/domains/sportsbook/webview/components/raceCard/tabs/Tabs.style';
import { TabsItem } from 'src/domains/sportsbook/webview/components/raceCard/tabs/TabsItem';
import { TabsState } from 'src/domains/sportsbook/webview/components/raceCard/tabs/Tabs.state';
import { TabItemType } from 'src/domains/sportsbook/webview/components/raceCard/tabs/Tabs.type';
import { FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export interface SwitcherPropsType {
    items: Array<TabItemType>;
}

const Switcher = observer('Switcher', (props: SwitcherPropsType): React.ReactElement | null => {
    const { items } = props;
    for (const x of items) {
        if (x.isActive()) {
            return x.content;
        }
    }

    return null;
});

export interface TabsPropsType {
    className?: string;
    items: Array<TabItemType>;
    setRefMenu?: (item: HTMLElement | null) => void;
    skin?: FiltersSkinType;
}

export const Tabs = observer('Tabs', (propsIn: TabsPropsType) => {
    const props = useAsObservableSource(propsIn);
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const [state] = React.useState(() => new TabsState(props));
    const { items, skin } = props;

    return (
        <TabsSection>
            <TabsUl
                key='tabs_ul'
                ref={state.setRefMenu}
                variant={configState.componentVariants.sportsbookVariant}
            >
                {items.map((tab) => {
                    if (tab.key === 'tomorrow') {
                        return <TomorrowLabel key={tab.key} />;
                    }
                    if (tab.key === 'thisWeek') {
                        return (
                            <TomorrowLabel
                                key={tab.key}
                                labelText='this-week'
                            />
                        );
                    }
                    return (
                        <TabsItem
                            key={tab.key}
                            item={tab}
                            skin={skin}
                        />
                    );
                })}
            </TabsUl>

            <TabsContent key='tabs-wrapper--content'>
                <Switcher items={items} />
            </TabsContent>
        </TabsSection>
    );
});
